import { motion } from "framer-motion";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ background: "var(--bg-primary)" }}
    >
      {/* Architectural grid pattern */}
      <div className="hero-pattern" />

      {/* Grain texture overlay */}
      <div className="grain-overlay" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
          {/* Decorative gold rule above heading */}
          <div className="flex justify-center mb-10">
            <div className="gold-rule" />
          </div>

          {/* Main headline */}
          <h1
            className="text-5xl md:text-7xl lg:text-[6.5rem] leading-[1.05] tracking-tight mb-8"
            style={{
              fontFamily: "var(--font-serif)",
              fontWeight: 300,
              color: "var(--text-primary)",
            }}
          >
            Where Capital
            <br />
            Meets Conviction
          </h1>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.4,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="text-base md:text-lg mb-12 max-w-2xl mx-auto"
          style={{
            fontFamily: "var(--font-sans)",
            fontWeight: 300,
            color: "var(--text-muted)",
            letterSpacing: "0.02em",
            lineHeight: 1.8,
          }}
        >
          Premium property advisory and development management across Australia
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.7,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <button
            data-testid="hero-approach-btn"
            onClick={() => scrollTo("approach")}
            className="btn-gold"
          >
            Our Approach
          </button>
          <button
            data-testid="hero-contact-btn"
            onClick={() => scrollTo("contact")}
            className="btn-outline"
          >
            Get in Touch
          </button>
        </motion.div>

        {/* Decorative gold rule below CTAs */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
          className="flex justify-center mt-16"
        >
          <div className="gold-rule" style={{ width: "120px" }} />
        </motion.div>
      </div>
    </section>
  );
};
